module.exports = __webpack_public_path__ + "img/personal-web09.72bbeee9.jpeg";